<template>
    <div>
        <UserTaskCounter />
        <UserGroupTaskCounter />
        <v-icon v-if="loading">mdi-loading mdi-spin</v-icon>
        <v-tooltip v-for="counter in counters" :key="counter.rank" bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="counter.href.includes('http')" :href="counter.href" icon v-bind="attrs" v-on="on">
                    <v-badge v-if="counter.count" color="primary" :content="counter.count">
                        <v-icon>{{ counter.icon }}</v-icon>
                    </v-badge>
                    <v-icon v-else>{{ counter.icon }}</v-icon>
                </v-btn>
                <v-btn v-else :to="counter.href" icon v-bind="attrs" v-on="on">
                    <v-badge v-if="counter.count" color="primary" :content="counter.count">
                        <v-icon>{{ counter.icon }}</v-icon>
                    </v-badge>
                    <v-icon v-else>{{ counter.icon }}</v-icon>
                </v-btn>
            </template>
            <span>{{ counter.name }}</span>
        </v-tooltip>
        <PrintCounter />

    </div>
</template>

<script>
import User from "@/models/User/User";
import Message from "@/models/Message/Message";
import AgentMessage from "@/models/Agent/Message/Message";
import sortBy from 'lodash/sortBy';
import Product from "@/models/Product/Product";
import eventBus from "@/plugins/EventBus";
import Dossier from "@/models/Dossier/Dossier";
import Proposal from "@/models/Proposal/Proposal";
import PrintCounter from "@/components/Layout/Partials/Counters/PrintCounter.vue";
import UserTaskCounter from "@/components/Layout/Partials/Counters/UserTaskCounter.vue";
import UserGroupTaskCounter from "@/components/Layout/Partials/Counters/UserGroupTaskCounter.vue";

export default {
    components: {
        PrintCounter,
        UserTaskCounter,
        UserGroupTaskCounter,
    },
    computed: {
        user() {
            return User.loggedInUser();
        },
    },
    data() {
        return {
            counters: [],
            loading: true,
            interval: null,
        }
    },
    methods: {
        async getCounters() {
            let promises = [];
            let counters = [];

            promises.push(Message.countUnread().then(result => {
                counters.push({
                    rank: 11,
                    href: '/user/messages',
                    icon: 'mdi-chat',
                    name: 'Berichten',
                    count: result,
                });
            }));

            if (this.user.HasPermission('products.without-margin')) {
                promises.push(Product.getUnassignedMarginProductCount().then(result => {
                    counters.push({
                        rank: 12,
                        href: '/product?search_by=all&display_has_margin=0',
                        icon: 'mdi-margin',
                        name: 'Producten zonder marge',
                        count: result,
                    });
                }));
            }
            if (this.user.Group().name === "CFS" || this.user.Group().name === "product" || this.user.Group().name === "Directie / IT") {
                promises.push(Dossier.getUncheckedAgentProductsCount().then(result => {
                    counters.push({
                        rank: 13,
                        href: '/dossiers/check',
                        icon: 'mdi-cash-check',
                        name: 'Inkoop ter controle',
                        count: result,
                    });
                }));
            }

            if (this.user.Group().name === "CFS" || this.user.Group().name === "product" || this.user.Group().name === "Directie / IT") {
                promises.push(Dossier.getUncheckedAgentAttachmentDownloadsCount().then(result => {
                    counters.push({
                        rank: 14,
                        href: '/dossiers/check-agent-attachment-downloads',
                        icon: 'mdi-download-multiple',
                        name: 'Downloads ter controle',
                        count: result,
                    });
                }));
            }

            if (this.user.Group().name === "CFS" || this.user.Group().name === "Tickets/IATA" || this.user.Group().name === "Directie / IT") {
                promises.push(Proposal.getReadyForTravelDocumentsCount().then(result => {
                    counters.push({
                        rank: 15,
                        href: '/proposals/bookings/travel-documents',
                        icon: 'mdi-wallet-travel',
                        name: 'Reisbescheiden klaarzetten',
                        count: result,
                    });
                }));
            }

            if (this.user.Group().name === "CFS" || this.user.Group().name === "product" || this.user.Group().name === "Directie / IT") {
                promises.push(AgentMessage.unvalidatedMessagesCount().then(result => {
                    counters.push({
                        rank: 16,
                        href: '/agent-messages',
                        icon: 'mdi-face-agent',
                        name: 'Agent berichten ter controle',
                        count: result,
                    })
                }));
            }

            return Promise.allSettled(promises).then(() => {
                this.counters = sortBy(counters, 'rank');
                this.loading = false;
            });
        },
    },
    created() {
        this.getCounters();
        this.interval = setInterval(() => {
            this.getCounters();
        }, 1000 * 60);

        eventBus().emitter.on("refreshCounters", () => {
            this.getCounters();
        });
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
}
</script>
